import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as BankActions from './bank.actions';
import { BankService } from 'app/modules/masters/bank/bank.service';
import { catchError, map, mergeMap, of } from 'rxjs';
import { Bank } from 'app/modules/masters/bank/models/bank.model';

@Injectable()
export class BankEffects {
  constructor(
    private actions$: Actions,
    private service: BankService,
  ) {}

  // LOAD with pagination (store-based)
  loadBanks$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BankActions.loadBanks),
      mergeMap(({ page, pageSize, sortBy, sortOrder, status, storeId }) =>
        this.service.getAll(page, pageSize, sortBy, sortOrder, status, storeId).pipe(
          map((res) =>
            BankActions.loadBanksSuccess({
              banks: res.data,
              total: res.total,
              page,
              pageSize,
              sortBy: res.sortBy as 'createdAt' | 'name' | 'accountType' | 'ifsc' | 'accountNumber' | 'currentBalance' | 'status',
              sortOrder: res.sortOrder,
            }),
          ),
          catchError((error) => of(BankActions.loadBanksFailure({ error }))),
        ),
      ),
    ),
  );

  // CREATE
  createBank$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BankActions.createBank),
      mergeMap(({ bank }) =>
        this.service.create(bank).pipe(
          map((created) => BankActions.createBankSuccess({ bank: created })),
          catchError((error) => of(BankActions.createBankFailure({ error }))),
        ),
      ),
    ),
  );

  // Note: Component handles reload after create via afterClosed() subscription

  // UPDATE
  updateBank$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BankActions.updateBank),
      mergeMap(({ id, bank }) =>
        this.service.update(id, bank).pipe(
          map((updated) => BankActions.updateBankSuccess({ bank: updated })),
          catchError((error) => of(BankActions.updateBankFailure({ error }))),
        ),
      ),
    ),
  );

  // Note: Component handles reload after update via afterClosed() subscription

  // DELETE
  deleteBank$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BankActions.deleteBank),
      mergeMap(({ id }) =>
        this.service.delete(id).pipe(
          map(() => BankActions.deleteBankSuccess({ id })),
          catchError((error) => of(BankActions.deleteBankFailure({ error }))),
        ),
      ),
    ),
  );

  // Note: Component handles reload after delete via subscription
}
